import EnglishModal from './EnglishModal'

export default EnglishModal
